export default "__VITE_ASSET__30b95da6__"